import React from 'react';
import { bool, shape, string } from 'prop-types';

const BlockColor = ({
  className = 'icon',
  notUseClass = false,
  color = '#696f88',
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={{ color, ...style }} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M8.25 11.25H5.25C4.0125 11.25 3 10.2375 3 9C3 7.7625 4.0125 6.75 5.25 6.75H8.25V5.25H5.25C3.18 5.25 1.5 6.93 1.5 9C1.5 11.07 3.18 12.75 5.25 12.75H8.25V11.25ZM12.75 5.25H9.75V6.75H12.75C13.9875 6.75 15 7.7625 15 9C15 10.2375 13.9875 11.25 12.75 11.25H9.75V12.75H12.75C14.82 12.75 16.5 11.07 16.5 9C16.5 6.93 14.82 5.25 12.75 5.25ZM12 8.25H6V9.75H12V8.25Z" fill="currentColor" />
  </svg>
);

BlockColor.propTypes = {
  className: string,
  notUseClass: bool,
  color: string,
  style: shape({}),
};

export default BlockColor;
